/* ============
 * Organizations Mutations
 * ============
 *
 * The mutations available for the organizations module.
 */

export const ALL = 'ALL';
export const SET_ALL = 'SET_ALL';
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';

export default {
  ALL,
  SET_ALL,
  SET_CURRENT_PAGE,
};



// WEBPACK FOOTER //
// ./src/store/modules/organizations/mutation-types.js